












import Vue, { PropType } from "vue";

// Vuex
import { mapActions, mapGetters } from "vuex";
import { GET_AVAILABLE_SOFTWARE_VERSIONS } from "@/store/modules/ApplicationModule/actions";

// Vue components
import SoftwareVersionsSubsetFilter from "@/components/TableHeaderFilters/SoftwareVersionsSubsetFilter.vue";

// Model
import { WidgetTypesEnum } from "@/model/data/dashboard/WidgetTypesEnum";
import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { GetI18nStringFromUpdateType, UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { NamedSoftwareVersion } from "@/model/data/updates/NamedSoftwareVersion";
import { InstalledSoftware } from "@/model/data/InstalledSoftware";
import { SoftwareVersionsSubset } from "@/model/data/updates/SoftwareVersionsSubset";
import { SoftwareName } from "@/model/data/updates/SoftwareName";
import { SoftwareVersionsFilter } from "@/model/data/updates/SoftwareVersionsFilter";

class SoftwareItem {
    swType: UpdateTypeEnum;
    name: string;
    text: string;

    constructor(swType: UpdateTypeEnum, name: string, text: string) {
        this.swType = swType;
        this.name = name;
        this.text = text;
    }
}

const ShowOnlyMultipleSelectionSwTypeList: UpdateTypeEnum[] = [UpdateTypeEnum.Firmware, UpdateTypeEnum.SensorFirmware, UpdateTypeEnum.SensorTemplate];

export default Vue.extend({
    components: {
        SoftwareVersionsSubsetFilter,
    },
    data() {
        return {
            WidgetTypesEnum,
            loading: false,
            selectedSw: null,
            softwareVersionsSubset: null,
            ignoreSelectedSwChanged: false,
        };
    },
    props: {
        widget: Object as PropType<DashboardWidget>,
    },
    computed: {
        ...mapGetters({ availableSoftwareNames: "availableSoftwareNames" }),

        availableSws() {
            let res: SoftwareItem[] = [];
            this.availableSoftwareNames.forEach((swName: SoftwareName) => {
                if (swName.swType == UpdateTypeEnum.ThirdPartySoftware) res.push(new SoftwareItem(swName.swType, swName.name, swName.name));
                else res.push(new SoftwareItem(swName.swType, swName.name, this.$t(GetI18nStringFromUpdateType(swName.swType))));
            });

            return res;
        },

        showOnlyMultipleSelection() {
            return (ShowOnlyMultipleSelectionSwTypeList as UpdateTypeEnum[]).some((c) => c == this.selectedSw.swType);
        },

        selectedVersions: {
            get() {
                return [];
            },
            set(versions: NamedSoftwareVersion[]) {
                this.widget.filter.bySoftware = [];
                versions.forEach((v: NamedSoftwareVersion) => {
                    let temp: InstalledSoftware = new InstalledSoftware();
                    temp.name = v.name;
                    temp.version = v.version;
                    temp.updateType = this.selectedSw.swType;
                    this.widget.filter.bySoftware.push(temp);
                });
            },
        },
    },
    watch: {
        selectedSw(newValue) {
            if (!this.ignoreSelectedSwChanged) {
                if (newValue != null) {
                    let swVersionsSubset: SoftwareVersionsSubset = new SoftwareVersionsSubset();
                    swVersionsSubset.updateType = this.selectedSw.swType;
                    swVersionsSubset.name = this.selectedSw.name;
                    this.softwareVersionsSubset = swVersionsSubset;
                } else this.softwareVersionsSubset = null;
            } else this.ignoreSelectedSwChanged = false;
        },

        softwareVersionsSubset(newSoftwareVersionsSubset) {
            // per il momento posso this.widget.filter.bySoftware.softwareVersionsSubsets ha al più un elemento, quindi spazzo via e ne creo uno nuovo
            // se in futuro si avranno più elementi, ricordarsi di settare correttamente this.widget.filter.bySoftware.logicalOperator
            this.widget.filter.bySoftware.softwareVersionsSubsets = [];
            if (newSoftwareVersionsSubset != null) this.widget.filter.bySoftware.softwareVersionsSubsets.push(newSoftwareVersionsSubset);
        },

        // widget: {
        //     handler(newWidget) {
        //         console.log("newWidget.filter: ", newWidget.filter);
        //         if (newWidget.filter.bySoftware != null)
        //             if (
        //                 (newWidget.filter.bySoftware as SoftwareVersionsFilter).softwareVersionsSubsets != null &&
        //                 (newWidget.filter.bySoftware as SoftwareVersionsFilter).softwareVersionsSubsets.length > 0
        //             ) {
        //                 this.softwareVersionsSubset = (newWidget.filter.bySoftware as SoftwareVersionsFilter).softwareVersionsSubsets[0];
        //             }
        //     },
        //     deep: true,
        // },
    },
    methods: {
        ...mapActions([GET_AVAILABLE_SOFTWARE_VERSIONS]),

        // setItems() {
        //     this.availableSoftwareFilter.forEach((obj: SoftwareFilter) => {
        //         var swType = obj.updateType;
        //         if (swType == UpdateTypeEnum.ThirdPartySoftware)
        //             obj.versionsList.forEach((v: NamedSoftwareVersion) => {
        //                 if (!this.availableSws.some((sw: SoftwareItem) => sw.name == v.name)) this.availableSws.push(new SoftwareItem(swType, v.name));
        //             });
        //         else this.availableSws.push(new SoftwareItem(swType, this.$t(GetI18nStringFromUpdateType(swType))));
        //     });
        // },
    },
    async mounted() {
        this.loading = true;

        if (!this.availableSoftwareNames || !this.availableSoftwareNames.length) await this[GET_AVAILABLE_SOFTWARE_VERSIONS]();
        if (this.widget.filter.bySoftware != null)
            if (
                (this.widget.filter.bySoftware as SoftwareVersionsFilter).softwareVersionsSubsets != null &&
                (this.widget.filter.bySoftware as SoftwareVersionsFilter).softwareVersionsSubsets.length > 0
            ) {
                this.ignoreSelectedSwChanged = true;
                this.selectedSw = ((this.widget.filter.bySoftware as SoftwareVersionsFilter).softwareVersionsSubsets[0] as SoftwareVersionsSubset).name;
                this.softwareVersionsSubset = (this.widget.filter.bySoftware as SoftwareVersionsFilter).softwareVersionsSubsets[0];
            }

        this.loading = false;
    },
});
